import React, { useCallback, useState } from 'react';

import { ReactComponent as EyeOffIcon } from '@pkg/assets/icons/v2/eye-off.svg';
import { ReactComponent as EyeIcon } from '@pkg/assets/icons/v2/eye.svg';

import { DepInput, type DepInputProps } from '../DepInput';

import './DepPassword.scss';

export function DepPassword({ append, ...props }: DepInputProps) {
    const [showPassword, setShowPassword] = useState(false);
    const type = showPassword ? 'text' : 'password';

    const handleShowPasswordClick = useCallback(
        function () {
            setShowPassword((_showPassword) => !_showPassword);
        },
        [setShowPassword],
    );

    return (
        <DepInput
            {...props}
            classes="yat-password-input"
            type={type}
            append={
                <>
                    <span className="yat-password-input__icon" onClick={handleShowPasswordClick}>
                        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                    </span>
                    {append}
                </>
            }
        />
    );
}
